import fp from 'lodash/fp'

const toName = fp.flow(fp.toLower, fp.split('_'), fp.join(' '), fp.upperFirst)

export const enumToOptions = fp.flow(
  fp.compact,
  fp.map((value) => ({
    id: value,
    name: toName(value),
  }))
)
